import React from 'react';
import { Sun, Droplets, Moon } from 'lucide-react';
import { getTheme, THEME_MODES } from './theme';

const MODE_META = {
  light: { label: 'Light', Icon: Sun },
  regular: { label: 'Regular', Icon: Droplets },
  dark: { label: 'Dark', Icon: Moon },
};

const ThemeToggleButton = ({
  colorMode = 'light',
  onChange,
  className = '',
  ...props
}) => {
  const currentTheme = getTheme(colorMode);
  const activeMode = THEME_MODES.includes(colorMode) ? colorMode : 'light';

  const containerStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    padding: 3,
    backgroundColor: currentTheme.colors.secondary,
    border: `1px solid ${currentTheme.colors.border.primary}`,
    borderRadius: 10,
    ...props.style,
  };

  const optionBase = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    cursor: 'pointer',
    padding: 7,
    borderRadius: 8,
    transition: 'background-color 0.2s ease, color 0.2s ease',
    lineHeight: 1,
  };

  return (
    <div
      style={containerStyles}
      className={className}
      role="radiogroup"
      aria-label="Tonalidad de color"
    >
      {THEME_MODES.map((mode) => {
        const { label, Icon } = MODE_META[mode];
        const isActive = activeMode === mode;
        return (
          <button
            key={mode}
            type="button"
            role="radio"
            aria-checked={isActive}
            aria-label={label}
            title={label}
            onClick={() => onChange?.(mode)}
            style={{
              ...optionBase,
              backgroundColor: isActive
                ? currentTheme.colors.interactive.primary
                : 'transparent',
              color: isActive
                ? currentTheme.colors.text.accent
                : currentTheme.colors.text.secondary,
            }}
          >
            <Icon size={14} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
};

export default ThemeToggleButton;
